<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-card class="mb-0">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Consumos y Cobros</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="wrapper">
        <Consumos
          v-if="visible"
          :idTurno="idTurno"
          :idInscripcion="idInscripcion"
          @actualizarTotal="actualizarTotalConsumido"
        />
        <NuevoCobro
          v-if="visible"
          :idTurno="idTurno"
          :idInscripcion="idInscripcion"
          :estadoTurno="estadoTurno"
          :pacienteTurno="pacienteTurno"
          :idProfesional="idProfesional"
          :idPacienteTurno="idPacienteTurno"
          :celular="celular"
          :nombrePaciente="nombrePaciente"
          @recargarLista="$emit('recargarLista')"
          @actualizarTotal="actualizarTotalPagado"
        />
        <div class="importes">
          <v-row class="mt-4 ml-1">
            <v-col cols="12" class="d-flex flex-wrap mt-auto importes-col">
              <div class="importe consumido">
                Total importe consumido: ${{ totalConsumido }}
              </div>
              <div class="importe pagado">
                Total importe pagado: ${{ totalPagado }}
              </div>
              <div class="importe saldo">Total saldo: {{ saldo }}</div>
              <v-text-field
                v-model="cantJugadores"
                label="Cant. Jugadores"
                outlined
                maxlength="2"
                class="cantidad-jugadores"
              ></v-text-field>
              <div class="importe division">
                Total por jugador: {{ toFixed(totalConsumido / cantJugadores) }}
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions class="mt-2">
        <v-spacer></v-spacer>
        <v-btn text color="grey lighten-1" @click.stop="show = false"
          >Salir</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Consumos from "./Consumos.vue";
import NuevoCobro from "./NuevoCobro.vue";

export default {
  props: {
    visible: {
      required: false,
    },
    idTurno: {
      required: false,
      default: 0,
    },
    idTorneo: {
      required: false,
      default: 0,
    },
    idInscripcion: {
      required: false,
      default: 0,
    },
    pacienteTurno: { required: false },
    idProfesional: { required: false },
    idPacienteTurno: { required: false },
    tipoMovimiento: { required: false, default: "cobro" },
    estadoTurno: { required: false, default: 0 },
    celular: { type: String, required: false, default: "" },
    nombrePaciente: { type: String, required: false, default: "" },
  },
  data() {
    return {
      delta: false,
      cantJugadores: null,
      totalConsumido: "0.00",
      totalPagado: "0.00",
    };
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.cantJugadores = this.idTurno > 0 ? 4 : 1;
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close", this.delta);
        }
      },
    },
    saldo() {
      return this.toFixed(this.totalConsumido - this.totalPagado);
    },
  },
  methods: {
    toFixed(resultado) {
      if (isNaN(resultado)) return `$ ${parseFloat(0).toFixed(2)}`;
      return `$ ${parseFloat(resultado).toFixed(2)}`;
    },
    actualizarTotalConsumido(total) {
      this.totalConsumido = total;
    },
    actualizarTotalPagado(total) {
      this.totalPagado = total;
    },
  },
  components: {
    Consumos,
    NuevoCobro,
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: grid;
  grid-template-columns: 35fr 65fr;
  padding: 0 !important;
  gap: 8px;
}

.importes {
  grid-column: span 2;
  width: 80%;

  :deep(.cantidad-jugadores) {
    flex: 0 1 170px;
    max-height: 50px;
  }

  :deep(.v-input__slot) {
    min-height: 50px;
  }
  .importes-col {
    gap: 1rem;
  }
}

/* Responsive */
@media (max-width: 1000px) {
  .wrapper {
    grid-template-columns: 1fr;
  }

  .importes {
    grid-column: auto; /* o span 1 */
    width: 100%;
    .importe {
      height: fit-content;
    }
  }
}
.importe {
  padding: 12px 6px;
  border-radius: 5px;
  color: white;
  height: 50px;
}
.consumido {
  border: 2px solid rgb(4, 99, 4);
  background: rgb(4, 121, 4);
}
.pagado {
  border: 2px solid rgb(0, 0, 121);
  background: rgb(3, 3, 230);
}
.saldo {
  border: 2px solid rgb(90, 2, 2);
  background: rgb(179, 5, 5);
}
.division {
  border: 2px solid rgb(44, 1, 75);
  background: indigo;
}
</style>
